// web/src/services/messagesService.js
import apiClient from './apiClient';
import toast from 'react-hot-toast';

/**
 * Get messages for user
 */
export const getMessagesForUser = async (userId) => {
  try {
    const data = await apiClient.getMessages({ userId });
    return { data, error: null };
  } catch (error) {
    // Suppress connection errors (expected when backend is down)
    const errorMessage = error?.message || error?.toString() || '';
    const isConnectionError = errorMessage.includes('Failed to fetch') || 
                              errorMessage.includes('ERR_CONNECTION_REFUSED') ||
                              error instanceof TypeError;
    
    if (!isConnectionError) {
      if (import.meta.env.DEV) {
        console.warn('Error fetching messages:', errorMessage);
      }
      toast.error(errorMessage || 'Failed to fetch messages');
    }
    return { data: null, error };
  }
};

/**
 * Send message
 */
export const sendMessage = async (messageData) => {
  try {
    const data = await apiClient.sendMessage(messageData);
    return { data, error: null };
  } catch (error) {
    console.error('Error sending message:', error);
    toast.error(error.message || 'Failed to send message');
    return { data: null, error };
  }
};

/**
 * Get conversations for user
 */
export const getConversations = async () => {
  try {
    const data = await apiClient.getConversations();
    return { data, error: null };
  } catch (error) {
    // Suppress connection errors
    const errorMessage = error?.message || error?.toString() || '';
    const isConnectionError = errorMessage.includes('Failed to fetch') || 
                              errorMessage.includes('ERR_CONNECTION_REFUSED') ||
                              error instanceof TypeError;
    
    if (!isConnectionError && import.meta.env.DEV) {
      console.warn('Error fetching conversations:', errorMessage);
    }
    return { data: [], error: null }; // Return empty array on error
  }
};

/**
 * Get conversation with specific user
 */
export const getConversation = async (userId, limit = 50) => {
  try {
    const data = await apiClient.getConversation(userId, limit);
    return { data, error: null };
  } catch (error) {
    // Suppress connection errors
    const errorMessage = error?.message || error?.toString() || '';
    const isConnectionError = errorMessage.includes('Failed to fetch') || 
                              errorMessage.includes('ERR_CONNECTION_REFUSED') ||
                              error instanceof TypeError;
    
    if (!isConnectionError && import.meta.env.DEV) {
      console.warn('Error fetching conversation:', errorMessage);
    }
    return { data: [], error: null };
  }
};

/**
 * Mark message as read
 */
export const markMessageAsRead = async (messageId) => {
  try {
    await apiClient.markMessageAsRead(messageId);
    return { data: true, error: null };
  } catch (error) {
    console.error('Error marking message as read:', error);
    return { data: null, error };
  }
};

/**
 * Get unread message count
 */
export const getUnreadCount = async () => {
  try {
    const data = await apiClient.getUnreadCount();
    return { data, error: null };
  } catch (error) {
    // Suppress connection errors
    const errorMessage = error?.message || error?.toString() || '';
    const isConnectionError = errorMessage.includes('Failed to fetch') || 
                              errorMessage.includes('ERR_CONNECTION_REFUSED') ||
                              error instanceof TypeError;
    
    if (!isConnectionError && import.meta.env.DEV) {
      console.warn('Error fetching unread count:', errorMessage);
    }
    return { data: { count: 0 }, error: null };
  }
};
